import createHttpClient from '../../axios/createHttpClient';

const httpClient = createHttpClient();

// coach
// eslint-disable-next-line
export const getFile = (clientToken, id, config = {}) => dispatch => {
  const sendRequest = httpClient
    .request({
      method: 'GET',
      url: `${clientToken}/files/${id}`,
      responseType: 'arraybuffer',
      ...config
    })
    .then(response => ({
      type: response.headers['content-type'], // https://developer.mozilla.org/en-US/docs/Web/API/Blob/type
      name: response.headers['X-Stadline-Content-Name'] || '', // https://developer.mozilla.org/en-US/docs/Web/API/File/name
      content: response.data // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsArrayBuffer
    }));

  return sendRequest;
};



// WEBPACK FOOTER //
// ./src/http-client/endpoints/fileApi/index.js